// extracted by mini-css-extract-plugin
export default {"versionLogs":"VersionLogs_versionLogs__ddqYA","md":"VersionLogs_md__oPL58"};